import loadingTools from '../loadingTools';
import qtiConstants from '../../../qti/Constants';

const { ACEEDITOR } = qtiConstants.staticLibPaths;

const ACEEditorLoader = {
    getCoreFile() {
        return { url: `${ACEEDITOR}ace.js` };
    },

    getExtraFiles(questions) {
        const workers = ['coffee', 'css', 'html', 'javascript', 'json', 'lua', 'php', 'xml', 'xquery'];

        return questions.reduce((foundModes, question) => {
            if (question.objectType !== 'content_question_qti2_code_editor') {
                return foundModes;
            }
            const regEx = /inspera:codeMode="([a-zA-Z0-9]+)"/gi;
            let goOn = true;

            while (goOn) {
                const matches = regEx.exec(question.itemBody);
                if (matches) {
                    const modeName = matches[1];
                    foundModes.push({ url: `${ACEEDITOR}mode-${modeName}.js` });
                    if (workers.includes(modeName)) {
                        foundModes.push({ url: `${ACEEDITOR}worker-${modeName}.js` });
                    }
                } else {
                    goOn = false;
                }
            }

            return foundModes;
        }, [{ url: `${ACEEDITOR}theme-eclipse.js` }]);
    },

    getAllFilesToCache(questions) {
        const files = [this.getCoreFile()];
        files.push(...this.getExtraFiles(questions));
        return files;
    },

    async init(questions) {
        return loadingTools
            .loadLibrary(this.getCoreFile().url, 'ace')
            .then(() => {
                return loadingTools.loadLibraries(
                    this.getExtraFiles(questions)
                );
            });
    },
};

export default ACEEditorLoader;
